window.updateDateTime = function (fresh = false){
	moment.tz.setDefault("UTC");
	$(".dateRaw").each(function(){
		if($(this).html()){
			if($(this).attr('date-raw-utc') !== undefined){
				var val = $(this).attr('date-raw-utc');
			}else{
				var val = $(this).html();
				$(this).attr('date-raw-utc', val);
			}
			
			var newVal = moment(val, 'YYYY-MM-DD HH:mm:ss').fromNow();
			if(newVal != "Invalid date"){
				$(this).html('<a title="' + val + '">' + newVal + '</a>');
			}
		}
	});
	moment.tz.setDefault();
}